import styled from 'styled-components';
import MembershipBadge from '../components/membership/MembershipBadge';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import PaymentHistory from './payment/paymentHistory';
import { useModal } from '../../context/ModalContext';
import RemainingTicket from './payment/RemainingTicket';

function Payment() {
  const navigate = useNavigate();
  const { user } = useUser();
  const { modalDispatch } = useModal();

  // 잔여일 계산 함수
  const calculateRemainingDays = (endDateStr?: string) => {
    if (!endDateStr) return null;

    const endDate = new Date(endDateStr);
    const today = new Date();

    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 밀리초 → 일

    return diffDays;
  };

  return (
    <Content>
      <Div>
        <MembershipDiv>
          <UserInformation>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ whiteSpace: 'nowrap' }}>
                {localStorage.getItem('userName')}님의 요금제
              </div>
              <Img
                src="/assets/images/arrow/arrow_right_24.svg"
                alt="arrow"
                onClick={() => {
                  navigate('/payment/plan');
                }}
              />
            </div>

            <MembershipBadge data={user || undefined} />
          </UserInformation>

          {user?.plan_grade && (
            <MembershipInformation>
              <MembershipPreiod>
                <div style={{ color: '#616161' }}>요금제 기간</div>
                <div>
                  {user?.plan_start?.slice(2).replace(/-/g, '.')}~
                  {user?.plan_end?.slice(2).replace(/-/g, '.')}
                </div>
              </MembershipPreiod>
              <MembershipPreiod>
                <div style={{ color: '#616161' }}>잔여일</div>
                <div>{calculateRemainingDays(user?.plan_end ?? '')}일</div>
              </MembershipPreiod>
            </MembershipInformation>
          )}
        </MembershipDiv>
      </Div>
      <RemainingTicket />
      <HistorySection>
        <PaymentHistory />
        <RefundDiv>
          <Comment>
            <CommentTop>
              <span>환불관련 도움이 필요하시면 문의주세요.</span>
              <Info>
                <span style={{ fontSize: '12px' }}>
                  월~금(공휴일 제외) 10:00~18:00
                </span>
                <span style={{ fontWeight: '700' }}>02-555-2822</span>
              </Info>
            </CommentTop>
          </Comment>
          <RefundButton
            onClick={() => {
              modalDispatch({ type: 'I' });
            }}
          >
            환불문의
          </RefundButton>
        </RefundDiv>
      </HistorySection>
    </Content>
  );
}

export default Payment;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Div = styled.div`
  width: 100%;
  padding: 40px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f8fc;
`;

const MembershipDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 20px;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
  background-color: #ffffff;
`;

const UserInformation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
`;

const MembershipInformation = styled.div`
  width: 100%;
  background-color: #f7f8fc;
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  border-radius: 8px;
`;

const MembershipPreiod = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
`;

const Img = styled.img`
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

const HistorySection = styled.div`
  display: flex;
  padding: 50px 16px 72px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 24px;
`;

const RefundDiv = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  background: #f7f8fc;
`;

const Comment = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

const CommentTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const RefundButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 48px;
  background-color: transparent;
  border-radius: 8px;
  border: 1px solid #008aff;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
  cursor: pointer;
`;
